import React, { Component } from "react"
import './index.css';
import { m } from '../../utils';
import ProgressBar from '../../artzu-ui/src/ProgressBar'
import Button from '../../artzu-ui/src/Button'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag';

const CREATE_BOOKING = gql`
  mutation createBookings($selectedShifts: [BookingAttributes!]!) {
    createBookings(shifts: $selectedShifts) {
      bookings {
        startTime
        endTime
        vehicleClass
        id
      }
      errors {
        message
        startTime
        endTime
        vehicleClass
      }
    }
  }
`;
class BookingFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      footerNotice: ""
    };
  }
  render() {
    const {
      display,
      promoProgress,
      duration,
      selectedShifts,
      footerButton,
      submitAction,
      resetParams,
      receiveConfirmation,
      showModal,
      pendBooking,
      media,
      backAction
    } = this.props;
    let progress = promoProgress + selectedShifts.filter(shift => {
      let weekStart = m().clone().startOf('isoWeek');
      let weekEnd = m().clone().endOf('isoWeek');
      return m(shift.startTime).isAfter(weekStart) && m(shift.startTime).isBefore(weekEnd);
    }).length * duration
    return (
      <Mutation
        mutation={CREATE_BOOKING}
        onCompleted={async ({ createBookings }) => {
          await this.setState({ disabled: false });
          await receiveConfirmation(createBookings);
          await submitAction();
          await pendBooking(false);
        }}>
        {createBookings => (
          <div className="book-footer">
            {media === "desktop" && display === "review" ? 
              <Button
                primary={display === "complete"}
                className="previous-button"
                label={display === "review" ? "Back" : "Book More"}
                onClick={backAction}
              /> : media === "desktop" && (display === "confirmation" || display === "complete") ?
              <div></div> : null}
          {this.renderNotice(display)}
          {display === "calendar" || display === "action" ? 
          <div className="promo-progress">
            <ProgressBar className="promo-bar" fillers={[progress === 0 ? 0 : (Math.max(Math.min(progress * 100 / (progress >= 50 ? 80 : 50), 100), 12))]} primaryColor="#414141" borderColor="#414141" />
            <h3 className="promo-count">{progress}/{progress >= 50 ? '80' : '50'}</h3>
          </div> : null}
          <Button 
            primary 
            fullWidth={media === "mobile"}
            className="submit-action"
            margin="0.5em 0"
            label={`${footerButton}`} 
            disabled={display === 'calendar' || display === 'action' ? selectedShifts.length <= 0 : this.state.disabled}
            onClick={
              selectedShifts.length > 0 && display === "review" ? 
                () => {
                  this.setState({disabled: true})
                  createBookings({ variables: { selectedShifts } });
                  resetParams();
                  pendBooking(true);
                } : 
                display === "editFilter" && selectedShifts.length > 0 ? showModal : submitAction
            }/>
        </div>
        )}
      </Mutation>
    )
  }

  renderNotice = (display) => {
    const { promoProgress, duration, selectedShifts } = this.props;
    let progress = promoProgress + selectedShifts.length * duration;
    switch(display) {
      case "calendar":
      case "action":
        return progress < 50 ? 
          <p className="footer-notice">Drive 50 hours a week and receive <strong>$50 credit</strong></p> :
          <p className="footer-notice">Drive 80 hours a week and receive <strong>$100 credit</strong></p>
      case "review":
        return (
          <p className="footer-notice" style={{padding: "0 1em"}}>
            *By clicking Book, you agree to the terms and conditions. View our <a href="/terms#cancel" target="_blank">Cancellation Policy</a>
          </p>
        )
      default:
        return null;
    }
  }
} 
export default BookingFooter;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingFooter.js